import { useEffect, useState } from "react";
import { withPermissions } from "../../../layout/Permissions";
import { PERMISSION_USER } from "../../user/constants/permissions";
import Folder from "../containers/Folder";
import { useParams } from "react-router-dom";

const FolderPage = () => {
  const [folderId, setFolderId] = useState("");

  const params = useParams();

  useEffect(() => {
    if (params && params.folderId) {
      setFolderId(params.folderId);
    }
  }, [params]);

  return <Folder folderId={folderId} />;
};
export default withPermissions(FolderPage, PERMISSION_USER);
